import {createApp} from 'vue'
import Store from 'store'
import QuickSearch from './QuickSearch'

const el = '.nlx-component--quick-search'
const DOM = document.querySelector(el)

if(DOM){
    const excelHelpLink = DOM.dataset.excelHelpLink || ''
    const component = createApp(QuickSearch, {excelHelpLink}).use(Store)
    component.mount(el)
}

